
import React, { useState, forwardRef, useRef } from 'react';
import {
    DialogContent, DialogTitle, Dialog, Paper, TextField, Box, Grid, Typography, TableCell, TableContainer,
    Table, TableHead, Button, IconButton, TableRow, TableBody, Accordion, AccordionDetails,
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
// import PurchaseEntryPrint from './PurchaseEntryPrint';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { StyledTableCell, StyledTableRow } from '../../reusableComponent/StyledTable';
import styles from '.././../../styles.module.css';
import PartiesAdd from './PartiesAdd';


const PartiesDetails = (props) => {
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const detailsView = props.details;
    const [open, setOpen] = useState(false)
    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleClickOpenPopup = (info) => {
        // setInfo(info);
        setOpen(true);
    };
    const navigate = useNavigate()

    const navigateToAddEdit = (row) => {
        const state = {
            ...row,
        };
        navigate('/masters/add-party-masters', { state });
    };

    return (
        <>

            <Paper className='mainContainer' sx={{ boxShadow: 'none' }}>

                <Box>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item md={10}>
                            <Grid container spacing={1} sx={{ mt: 0 }}>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Party Name</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`} >{detailsView.CNS_Name}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Party Type</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.CNS_Type}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Supplier Type</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{(detailsView.supplierType === '' || detailsView.supplierType === null) ? '-' : detailsView.supplierType}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Address</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.address)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>City</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.city}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Pincode</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.pinCode)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>State</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.state}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Contact Person</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.contactPerson)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Mobile No</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.mobileNo)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Email Id</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.emailId)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>GSTIN</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.gstn)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Pan No</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.panNo)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Credit Period</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.creditPeriod)} days</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Credit Limit</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.creditLimit)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Openng Balance</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.openingBalance)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Joining Date</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {dateConversion(detailsView.CNS_JoiningDate)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Vendor Code</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.vendorCode)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Bank Name</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.bankName)}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography className={`${styles.detail_lable}`}>Balance Type</Typography>
                                </Grid>
                                <Grid item md={0.4}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item md={9.5}>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.balanceType)}</Typography>
                                </Grid>





















                            </Grid>
                        </Grid>
                        <Grid item md={2}>
                            <Box >
                                <Grid container spacing={0} >
                                    <Grid item md={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                        <Box sx={{ marginBottom: '6px' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'right', }}>
                                                <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} onClick={() => navigateToAddEdit(detailsView)} />
                                            </Box>
                                            < Box >
                                                <Icon icon="clarity:email-line" width="19" height="19" color="red" style={{}} />
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Paper >
            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "85%",
                        maxHeight: 600,
                        minWidth: "30%",
                        minHeight: 120
                    }
                }}
                onClose={handleClose}
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    Update Party
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <PartiesAdd handleCloseDialog={handleClose} details={detailsView} />
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}
export default PartiesDetails;